import styled from 'styled-components';
import { Box } from '@interstate/components/Box';

export const VehicleInfoItemContainer = styled(Box)`
    border-radius: 4px;
    background: var(--surface-subdued, ${({ theme }) => theme.tokens.BaseColorGray50});
    padding: 16px;
    gap: 4px;
    align-self: stretch;
    margin-bottom: 32px;
    .rowItem {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        gap: 4px;
        .label {
            padding-bottom: 6px;
            padding-left: 0;
        }
        .vehicleInfoValue {
            text-align: right;
        }
    }
`;

export const VehicleInfoGrid = styled.div<{
    isVerticalMarginsRequired?: boolean;
    gridTemplateColumns?: string;
    gap?: string;
    position?: string;
}>`
    display: grid;
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns || 'repeat(2, 1fr)'};
    gap: ${({ gap }) => gap || '1rem'};
    ${({ isVerticalMarginsRequired }) =>
        isVerticalMarginsRequired &&
        `
            margin: 1rem 0;
        `}
    ${({ position }) => position && `position: ${position};`}
`;

export const LinkContainer = styled.div`
    display: flex;
    gap: 1rem;
    width: fit-content;
    span {
        white-space: nowrap; // Prevent Action label break the line
        font-size: 1.28rem !important;
    }
`;

// No-vehicle (quote) flyout header: Inventory Type dropdown + Add Vehicle/vAuto links.
// 12px between the dropdown and the links, 32px down to the fields.
export const NoVehicleHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 32px;
`;

export const NoVehicleLinks = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    width: fit-content;
    span {
        white-space: nowrap;
    }
`;

export const TrimStockEditCard = styled(Box)`
    border-radius: 4px;
    background: var(--surface-subdued, ${({ theme }) => theme.tokens.BaseColorGray50});
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    align-self: flex-start;
`;

export const DrawerContent = styled(Box)`
    flex-grow: 1;

    body {
        background: unset;
    }
`;

export const VehicleImageContent = styled(Box)`
    border-radius: 6px;
    overflow: hidden;
    object-fit: cover;
`;

export const StyledVehicleNotes = styled(Box)`
    margin-top: 32px;
`;
